import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class ToolsService {
  constructor(http) {
    this.http = http;
  }

  async resetSandbox() {
    await this.http.fetch('sandbox/reset', { method: 'POST' });
  }

  async getSandboxStatus() {
    const response = await this.http.fetch('sandbox/status');
    return await response.json();
  }

  async getUsers() {
    const response = await this.http.fetch('users');
    return await response.json();
  }

  async updateRoles(userRoles) {
    await this.http.fetch('users/roles', { method: 'PUT', body: json(userRoles) });
  }

  async getRoles() {
    const response = await this.http.fetch('users/roles');
    return await response.json();
  }
}